import { defineMessages } from 'react-intl';

export const scope = 'app.components.side_panel';

export default defineMessages({
  close_panel: {
    id: `${scope}.close_panel`,
    defaultMessage: 'Close panel',
  },
});
